import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas, SelectorContainer } from '../../styles';

export const GameInfoReportsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    grid-area: ${GameCenterComponentGridAreas.gameInfoReports};
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const InfoReportSelector = styled(SelectorContainer)`
    max-width: 342px;
    align-self: center;
`;

export const GameInfoReportHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
`;
